"use strict";

define('components/charts',[
    'components/charts/loaders/columns_chart',
    'components/charts/loaders/piechart',
    'components/charts/loaders/cashflow_summary_chart',
    'components/charts/loaders/cashflow_history_chart'
], function(
    columns_chart,
    piechart,
    cashflow_summary_chart,
    cashflow_history_chart
) {
    var chartsComponent = {
        init: function () {
            chartsComponent._initPage();
            $('.chart-list').on('jsq:tabLoaded', chartsComponent._initPage);
        },

        _initPage: function() {
            chartsComponent._startListeningForWindowResize();
            chartsComponent._startListeningForToggleClicks();
            chartsComponent._initChartSelectors();
            chartsComponent._initAllCharts();
        },

        _startListeningForWindowResize: function() {
            if (chartsComponent._onWindowResize) return;
            chartsComponent._onWindowResize = function() {
                clearTimeout(chartsComponent._resizeTimer);

                // A very small timeout such as 0 would work just fine, redrawing the charts is quick
                // because the underlying data is not being reconstructed.
                chartsComponent._resizeTimer = setTimeout(chartsComponent._resize, 10);
            };
            $(window).on('resize', chartsComponent._onWindowResize);
        },

        _initChartSelectors: function() {
            $('select.chart_selector').each(function() {
                var $select = $(this);
                if ($select.data('isInitialized')) return;
                $select.data('isInitialized', true);
                $select.change(function() {
                    var selectedChartId = $select.val();
                    $select.find('option').each(function(i, option) {
                        var chartId = $(option).val();
                        $('#' + chartId).toggle(selectedChartId == chartId);
                    });
                    chartsComponent._redrawAndInit();
                });
            });
        },

        // Charts need to be rerendered after clicking on toggle buttons.
        _startListeningForToggleClicks: function() {
            if (chartsComponent._listeningForToggleClicks) return;
            $(document.body).on('click', '[data-toggle], .show-hidden-rows', function() {
                // Redraw on the next ui loop to wait until the effects of the click have been applied.
                setTimeout(chartsComponent._redrawAndInit, 0);
            });
            chartsComponent._listeningForToggleClicks = true;
        },

        _initAllCharts: function() {
            $('.chart_container').each(function(){
                chartsComponent._initChart($(this));
            });
        },

        _initChart: function (chartContainer) {
            if (!chartContainer.is(':visible')) return;
            if (chartContainer.data('isInitialized')) return;
            chartContainer.data('isInitialized', true);

            var chartType = chartContainer.data('type');
            var loader = chartsComponent.chartLoadersByType[chartType];
            if (loader) {
                var chart = loader(chartContainer);

                // Use `data-chart-ready="true"` to indicate to wkhtmltopdf
                // that this chart has been drawn.
                var readyHandler = google.visualization.events.addListener(chart.instance, 'ready', function() {
                    chartContainer.attr('data-chart-ready', 'true');
                    google.visualization.events.removeListener(readyHandler);
                });

                // Draw the chart only after we register the 'ready' event'
                chart.draw();

                if (chart && typeof chart.redraw == 'function') {
                    chartsComponent._redrawList.push({
                        chartContainer: chartContainer,
                        chart: chart
                    });
                    if (chart.shouldRedrawOnWindowResize) {
                        chartsComponent._resizeList.push({
                            chartContainer: chartContainer,
                            chart: chart
                        });
                    }
                }
            } else {
                throw('Unsupported chart type: ' + chartType);
            }
        },

        _resizeTimer: null,
        _redrawList: [],
        _resizeList: [],
        _onWindowResize: null,
        _redrawAndInit: function() {
            chartsComponent._redraw();
            chartsComponent._initPage();
        },
        _redraw: function() {
            chartsComponent._redrawList = chartsComponent._redrawInList(chartsComponent._redrawList);
        },
        _resize: function() {
            chartsComponent._resizeList = chartsComponent._redrawInList(chartsComponent._resizeList);
        },
        _redrawInList: function(list) {
            var activeList = [];
            list.forEach(function(x) {
                if ($.contains(document.body, x.chartContainer[0])) {
                    activeList.push(x);
                    x.chart.redraw();
                }
            });
            return activeList;
        },

        /** `chartsComponent.chartLoadersByType` is a registry of supported chart types
        and their corresponding loader functions. Each type of chart should have its own file
        in 'components/charts/loaders' and be added into `chartsComponent.chartLoadersByType`.
        **/
        chartLoadersByType: {
            piechart: piechart,
            cashflow_summary: cashflow_summary_chart,
            cashflow_history: cashflow_history_chart,
            columns: columns_chart
        },
    };

    return chartsComponent;
});

